/* Plantenpot-finder — selectie, "samen"-balk, quick-view (vergrootglas), plant+pot in winkelwagen. Zelfstandig, inline-stijl. */
(function(){
  function ringColor(){
    try { var b=getComputedStyle(document.documentElement).getPropertyValue('--color-button').trim(); if(b) return 'rgb('+b+')'; } catch(e){}
    return '#a0623a';
  }
  function init(root){
    if(root.getAttribute('data-pd-init')) return;
    root.setAttribute('data-pd-init','1');
    var CURR = root.dataset.currency || 'EUR';
    var plantPrice = parseInt(root.dataset.plantPrice,10)||0;
    var plantVid = root.dataset.plantVid;
    var tray = root.querySelector('[data-pd-tray]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('.potcard'));
    var RING = ringColor();
    var selected = null;
    var COMBO = 1 - ((parseFloat(root.dataset.comboPct)||0)/100);
    var I18N={busy:root.dataset.i18nBusy||'Bezig...',choose:root.dataset.i18nChoose||'Kies deze pot',size:root.dataset.i18nSize||'Formaat',material:root.dataset.i18nMaterial||'Materiaal',color:root.dataset.i18nColor||'Kleur',diameter:root.dataset.i18nDiameter||'Diameter'};

    function money(c){ try { return new Intl.NumberFormat('nl-NL',{style:'currency',currency:CURR}).format(c/100);}catch(e){return '€ '+(c/100).toFixed(2).replace('.',',');} }
    function setMag(card,on){ var z=card.querySelector('.potcard__zoom'); if(z) z.style.opacity = on?'1':'0'; }
    function setSel(card,on){
      var media=card.querySelector('.potcard__media');
      var check=card.querySelector('.potcard__check');
      if(media) media.style.boxShadow = on ? ('0 0 0 3px '+RING) : 'inset 0 0 0 1.5px rgba(0,0,0,0.06)';
      if(check) check.style.display = on?'flex':'none';
      setMag(card,on);
    }
    function select(card){
      if(card.getAttribute('data-pd-avail')==='false') return;
      if(selected===card){ setSel(card,false); selected=null; if(tray) tray.style.display='none'; return; }
      if(selected) setSel(selected,false);
      setSel(card,true); selected=card;
      var potPrice=parseInt(card.getAttribute('data-pd-price'),10)||0;
      var q=function(s){return root.querySelector(s);};
      if(q('[data-pd-tthumb]')) q('[data-pd-tthumb]').src=card.getAttribute('data-pd-img')||'';
      if(q('[data-pd-tname]')) q('[data-pd-tname]').textContent=card.getAttribute('data-pd-name')||'Pot';
      if(q('[data-pd-plantp]')) q('[data-pd-plantp]').textContent=money(plantPrice);
      if(q('[data-pd-potp]')) q('[data-pd-potp]').textContent=money(Math.round(potPrice*COMBO));
      if(q('[data-pd-total]')) q('[data-pd-total]').textContent=money(plantPrice+Math.round(potPrice*COMBO));
      if(tray) tray.style.display='block';
    }

    /* ---- Quick-view modal ---- */
    var modal=document.createElement('div');
    modal.style.cssText='position:fixed;inset:0;z-index:100000;display:none;align-items:center;justify-content:center;padding:2rem;font-family:var(--font-body-family);';
    modal.innerHTML=
      '<div data-qv-bd style="position:absolute;inset:0;background:rgba(0,0,0,0.5);backdrop-filter:blur(3px);"></div>'+
      '<div style="position:relative;background:rgb(var(--color-background));border-radius:22px;width:min(78rem,100%);max-height:88vh;overflow:auto;box-shadow:0 24px 70px rgba(0,0,0,.3);">'+
        '<button data-qv-close aria-label="Sluiten" style="position:absolute;top:1.2rem;right:1.2rem;z-index:2;width:3.4rem;height:3.4rem;border-radius:50%;border:0;background:#F4F3EF;cursor:pointer;font-size:2.2rem;line-height:1;color:#333;">&times;</button>'+
        '<div style="display:flex;flex-wrap:wrap;gap:2.4rem;padding:2.6rem;">'+
          '<div style="flex:1 1 30rem;min-width:26rem;">'+
            '<div style="width:100%;aspect-ratio:1;border-radius:16px;overflow:hidden;background:#F4F3EF;"><img data-qv-main alt="" style="width:100%;height:100%;object-fit:cover;display:block;"></div>'+
            '<div data-qv-thumbs style="display:flex;gap:0.8rem;margin-top:1rem;flex-wrap:wrap;"></div>'+
          '</div>'+
          '<div style="flex:1 1 26rem;min-width:24rem;">'+
            '<h3 data-qv-name style="font-size:2.2rem;font-weight:700;letter-spacing:-0.01em;margin:0 0 0.4rem;color:rgb(var(--color-foreground));"></h3>'+
            '<div data-qv-price style="font-size:1.9rem;font-weight:700;margin:0 0 1.8rem;color:rgb(var(--color-foreground));"></div>'+
            '<dl data-qv-specs style="margin:0 0 1.8rem;"></dl>'+
            '<p data-qv-desc style="font-size:1.5rem;line-height:1.6;color:rgba(var(--color-foreground),0.75);margin:0 0 2.2rem;"></p>'+
            '<button data-qv-pick style="border:0;cursor:pointer;font-family:inherit;font-size:1.5rem;font-weight:600;padding:1.3rem 2.4rem;border-radius:980px;background:rgb(var(--color-button));color:rgb(var(--color-button-text));">'+I18N.choose+'</button>'+
          '</div>'+
        '</div>'+
      '</div>';
    document.body.appendChild(modal);
    var qvMain=modal.querySelector('[data-qv-main]'), qvThumbs=modal.querySelector('[data-qv-thumbs]');
    function closeQV(){ modal.style.display='none'; document.body.style.overflow=''; }
    modal.querySelector('[data-qv-bd]').addEventListener('click',closeQV);
    modal.querySelector('[data-qv-close]').addEventListener('click',closeQV);
    document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&modal.style.display==='flex') closeQV(); });

    function openQV(card){
      var imgs=[]; try{ imgs=JSON.parse(card.getAttribute('data-pd-images')||'[]'); }catch(e){}
      imgs=imgs.filter(Boolean);
      if(!imgs.length && card.getAttribute('data-pd-img')) imgs=[card.getAttribute('data-pd-img')];
      qvMain.src=imgs[0]||'';
      qvThumbs.innerHTML='';
      if(imgs.length>1) imgs.slice(0,8).forEach(function(u,i){
        var t=document.createElement('img'); t.src=u; t.alt='';
        t.style.cssText='width:5.6rem;height:5.6rem;border-radius:10px;object-fit:cover;cursor:pointer;flex:0 0 auto;box-shadow:inset 0 0 0 '+(i===0?('2px '+RING):'1px rgba(0,0,0,0.12)')+';';
        t.addEventListener('click',function(){ qvMain.src=u; Array.prototype.forEach.call(qvThumbs.children,function(c,j){ c.style.boxShadow='inset 0 0 0 '+(c===t?('2px '+RING):'1px rgba(0,0,0,0.12)'); }); });
        qvThumbs.appendChild(t);
      });
      modal.querySelector('[data-qv-name]').textContent=card.getAttribute('data-pd-name')||'';
      var qvp=parseInt(card.getAttribute('data-pd-price'),10)||0;
      modal.querySelector('[data-qv-price]').innerHTML='<span style="color:#1a7f37;">'+money(Math.round(qvp*COMBO))+'</span> <s style="font-size:1.4rem;font-weight:500;color:rgba(0,0,0,0.4);">'+money(qvp)+'</s> <span style="display:block;font-size:1.2rem;font-weight:600;color:#1a7f37;">'+(root.dataset.i18nWithplant||'met plant')+'</span>';
      var specs=modal.querySelector('[data-qv-specs]'); specs.innerHTML='';
      function row(label,val){ if(!val) return; var d=document.createElement('div'); d.style.cssText='display:flex;justify-content:space-between;gap:1.2rem;padding:0.9rem 0;border-bottom:1px solid rgba(0,0,0,0.08);'; var dt=document.createElement('dt'); dt.style.cssText='font-size:1.4rem;color:rgba(var(--color-foreground),0.55);'; dt.textContent=label; var dd=document.createElement('dd'); dd.style.cssText='font-size:1.4rem;font-weight:600;margin:0;color:rgb(var(--color-foreground));text-align:right;'; dd.innerHTML=val; d.appendChild(dt); d.appendChild(dd); specs.appendChild(d); }
      var dia=card.getAttribute('data-pd-dia'), hoog=card.getAttribute('data-pd-hoog');
      if(dia&&hoog) row(I18N.size,'&#216; '+dia+' x H '+hoog+' cm');
      else if(dia) row(I18N.diameter,'&#216; '+dia+' cm');
      row(I18N.material,card.getAttribute('data-pd-mat'));
      row(I18N.color,card.getAttribute('data-pd-kleur'));
      var desc=card.getAttribute('data-pd-desc'), dEl=modal.querySelector('[data-qv-desc]');
      dEl.textContent=desc||''; dEl.style.display=desc?'block':'none';
      modal.querySelector('[data-qv-pick]').onclick=function(){ closeQV(); select(card); };
      modal.style.display='flex'; document.body.style.overflow='hidden';
    }

    /* ---- Bindings ---- */
    var noHover = window.matchMedia && window.matchMedia('(hover:none)').matches;
    cards.forEach(function(c){
      c.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); select(c); });
      c.addEventListener('keydown', function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); select(c); } });
      if(noHover){ setMag(c,true); }
      else {
        c.addEventListener('mouseenter', function(){ setMag(c,true); });
        c.addEventListener('mouseleave', function(){ if(c!==selected) setMag(c,false); });
      }
      var z=c.querySelector('.potcard__zoom');
      if(z) z.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); openQV(c); });
    });

    function addToCart(btn, items){
      var old=btn.innerHTML;
      btn.disabled=true; btn.textContent=I18N.busy;
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
        .then(function(r){ if(!r.ok) throw 0; return r.json(); })
        .then(function(){ window.location.href='/cart'; })
        .catch(function(){ btn.disabled=false; btn.innerHTML=old; });
    }
    var addBtn=root.querySelector('[data-pd-add]');
    if(addBtn) addBtn.addEventListener('click', function(e){
      e.preventDefault(); if(!selected) return;
      addToCart(addBtn, [{id:plantVid,quantity:1},{id:selected.getAttribute('data-pd-pot'),quantity:1}]);
    });
    var addPotBtn=root.querySelector('[data-pd-add-pot]');
    if(addPotBtn) addPotBtn.addEventListener('click', function(e){
      e.preventDefault(); if(!selected) return;
      addToCart(addPotBtn, [{id:selected.getAttribute('data-pd-pot'),quantity:1}]);
    });
  }
  function boot(){ var n=document.querySelectorAll('[data-potdock]'); for(var i=0;i<n.length;i++) init(n[i]); }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
})();
